module.exports = __webpack_public_path__ + "static/pdn-201509.ee8c2b8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/pdn-201509.jpg
// module id = 665
// module chunks = 174759553322802